export default __webpack_public_path__ + "3cdb7b94bb8b83b93acade06a0f6323d.pdf";